import Toggle from "PFComponents/toggle/toggle";
import safePrune from "PFCore/helpers/safe_prune";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import PropTypes from "prop-types";
import React from "react";

import profilesToTable from "../helpers/profiles_to_table";
import css from "./csv_preview.less";

const CsvPreview = ({ profileIndex, exportableProfiles, order, config, setConfig }) => {
  const { removeEmptyColumns } = config;
  const { formatDateTime } = useDateFormatter();

  const profiles = exportableProfiles.filterEnabled();
  const [headers, items] = profilesToTable(profiles, order, {
    removeEmptyColumns,
    hidden: config.hidden,
    isBlindModeOn: config.isBlindModeOn,
    formatDate: formatDateTime
  });

  return (
    <div className={css.root}>
      <Toggle
        inline
        onChange={(val) => setConfig((prev) => ({ ...prev, removeEmptyColumns: val }))}
        checked={removeEmptyColumns}
        label="Remove empty columns"
      />
      <div className={css.tableWrap}>
        <table className={css.table}>
          <thead>
            <tr>
              {headers.map((text, index) => (
                <th key={`${text}+${index}`}>{text}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((row, index) => (
              <tr className={profileIndex === index ? css.current : null} key={`${row.id}+${index}`}>
                {row.map((text, cellIndex) => (
                  <td key={headers[cellIndex]}>{safePrune(text, 200)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CsvPreview.propTypes = {
  profileIndex: PropTypes.number.isRequired,
  exportableProfiles: PropTypes.object.isRequired,
  order: PropTypes.arrayOf(PropTypes.string).isRequired,
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired
};

export default CsvPreview;
